<template>
<main-content>
<kt-panel>
    <kt-panel-body id="sheba_number_repeater">
        <kt-form-section data-repeater-list="sheba_numbers">
            <kt-form-group hor data-repeater-item :style="{display: 'none'}">
                <div class="kt-input-icon kt-input-icon--left col-12 col-sm-9 col-lg-10">
                    <kt-row>
                        <kt-col lg="9" md="9" sm="12" xs="12">
                            <kt-form-group>
                                <kt-form-label class="ml-2">
                                    {{ $t('panel.profile.bankAccount.shebaNumber') }}
                                </kt-form-label>
                                <kt-input-group class="" id="sheba_number">
                                    <kt-form-control onkeyup="checkSheba(event)" dir="ltr" data-id="0"
                                                     name="inner-text-input-sheba" aria-describedby="national_code-error">
                                    </kt-form-control>
                                    <kt-input-group-append>
                                        <kt-input-group-text>IR</kt-input-group-text>
                                    </kt-input-group-append>
                                </kt-input-group>
                            </kt-form-group>
                        </kt-col>
<!--                        <kt-col lg="6" md="6" sm="12" xs="12">-->
<!--                            <kt-form-group>-->
<!--                                <kt-form-label>-->
<!--                                    {{ $t('panel.profile.bankAccount.cardNumber') }}-->
<!--                                </kt-form-label>-->
<!--                                <kt-input-group class="" id="card_number">-->
<!--                                    <kt-form-control  onkeyup="checkCardNumber(event)" dir="ltr"  data-id="1"-->
<!--                                                      name="inner-text-input-cardNumber" aria-describedby="national_code-error">-->
<!--                                    </kt-form-control>-->
<!--                                </kt-input-group>-->
<!--                            </kt-form-group>-->
<!--                        </kt-col>-->
                    </kt-row>
                </div>
                <div class="col-12 col-sm-3 col-lg-2 mb-lg-5 pl-lg-3 pr-lg-3 mb-md-5 pl-md-5 pr-md-5 mb-sm-5 mt-auto mb-auto">
                    <kt-form-group>
                        <a data-repeater-delete class="w-100 p-2 pt-3 btn-sm h-100 btn btn-label-danger btn-bold float-right">
                            <i class="la la-trash-o"></i>
                            {{ $t('btn.delete') }}
                        </a>
                    </kt-form-group>
                </div>
<!--                v-for="shebaNumber in sheba_numbers" v-bind:key="shebaNumber.id"-->
            </kt-form-group>
            <kt-form-group  hor data-repeater-item v-for="bankAccount in bankAccounts" v-bind:key="bankAccount.sheba_id">
                <div class="kt-input-icon kt-input-icon--left col-12 col-sm-9 col-lg-10">
                    <kt-row>
                        <kt-col lg="9" md="9" sm="12" xs="12">
                            <kt-form-group>
                                <kt-form-label>
                                    {{ $t('panel.profile.bankAccount.shebaNumber') }}
                                </kt-form-label>
                                <kt-input-group class="" id="sheba_number">
                                    <kt-form-control onkeyup="checkSheba(event)" dir="ltr" name="inner-text-input-sheba"
                                                     aria-describedby="national_code-error" :data-id="bankAccount.sheba_id"
                                                     :value="bankAccount.shebaNumber"></kt-form-control>
                                    <kt-input-group-append>
                                        <kt-input-group-text>IR</kt-input-group-text>
                                    </kt-input-group-append>
                                </kt-input-group>
                            </kt-form-group>
                        </kt-col>
<!--                        <kt-col lg="6" md="6" sm="12" xs="12">-->
<!--                            <kt-form-group>-->
<!--                                <kt-form-label>-->
<!--                                    {{ $t('panel.profile.bankAccount.cardNumber') }}-->
<!--                                </kt-form-label>-->
<!--                                <kt-input-group class="" id="card_number">-->
<!--                                    <kt-form-control onkeyup="checkCardNumber(event)" dir="ltr" :data-id="bankAccount.bankAccount_id"-->
<!--                                                     name="inner-text-input-card_number" aria-describedby="national_code-error"-->
<!--                                                     :value="bankAccount.cardNumber">-->
<!--                                    </kt-form-control>-->
<!--                                </kt-input-group>-->
<!--                            </kt-form-group>-->
<!--                        </kt-col>-->
                    </kt-row>
                </div>
                <div class=" col-12 col-sm-3 col-lg-2 mb-lg-5 pl-lg-3 pr-lg-3 mb-md-5 pl-md-5 pr-md-5 mb-sm-5 mt-auto mb-auto">
                    <kt-form-group>
                        <a data-repeater-delete class="w-100 h-100 p-2 pt-3 btn-sm btn btn-label-danger btn-bold float-right">
                            <i class="la la-trash-o"></i>
                            {{ $t('btn.delete') }}
                        </a>
                    </kt-form-group>
                </div>
            </kt-form-group>
        </kt-form-section>
        
        <kt-form-group hor>
            <a data-repeater-create class="btn btn-bold btn-sm btn-label-brand">
                <i class="la la-plus"></i> {{ $t('btn.add') }}
            </a>
        </kt-form-group>

        <kt-form-action class="row mt-4">
            <button class="btn btn-md btn-success btn-wide" @click="submitForm" id="submit_btn">
                {{ $t('btn.update') }}
            </button>
        </kt-form-action>
    </kt-panel-body>
</kt-panel>
</main-content>
</template>

<script>
import mainContent from './Base'
import $ from 'jquery'
import { shebaNumberService } from '@/common/api.service'
import { mapGetters } from 'vuex'
import Inputmask from 'inputmask'
import IranSheba from 'iran-sheba'
import {cardNumber} from '@/constants/cardNumber'
import { KTApp } from '@/plugins/core/app'
import { KTUtil } from '@/plugins/core/util'

window.checkSheba = function(e) {
    const value = $(e.target).prop('value')
    const bank  = IranSheba.recognize('IR'+value.split('-').join(''))
    if(bank) {
        new Promise((resolve, reject) => {
            let elem = document.getElementById($(e.target).prop('name')+'-icon')
            if(elem) {
                elem.parentNode.removeChild(elem)
            }

            resolve()
        }).then(() => {
            const input_el = '<span id="'+$(e.target).prop('name')+'-icon" class="kt-input-icon__icon kt-input-icon__icon--left w-auto px-3">'
                + '<span class="font-weight-bold text-primary">'+bank.persianName+'</span>'
                + '</span>'
            
            $(e.target).closest('.kt-input-icon').append(input_el)
        })
    }else {
        let elem = document.getElementById($(e.target).prop('name')+'-icon')
        if(elem) {
            elem.parentNode.removeChild(elem)
        }
    }
}

window.checkCardNumber = function(e) {
    const value = $(e.target).prop('value')
    const bankCode = value.split('-').join('').substr(0, 6)
    if (cardNumber.hasOwnProperty(bankCode)) {
        new Promise((resolve, reject) => {
            let elem = document.getElementById($(e.target).prop('name')+'-icon')
            if(elem) {
                elem.parentNode.removeChild(elem)
            }

            resolve()
        }).then(() => {
            const input_el = '<span id="'+$(e.target).prop('name')+'-icon" class="kt-input-icon__icon kt-input-icon__icon--left w-auto px-3">'
                + '<span class="font-weight-bold text-primary">'+cardNumber[bankCode]+'</span>'
                + '</span>'
            $(e.target).closest('.kt-input-icon').append(input_el)
        })
    } else {
        let elem = document.getElementById($(e.target).prop('name')+'-icon')
        if(elem) {
            elem.parentNode.removeChild(elem)
        }
    }
}

export default {
    components: {
        'main-content': mainContent
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('user/fetchCurrent')
            vm.$store.dispatch('shebaNumber/fetchBankAccount')
        })
    },
    computed: {
        ...mapGetters('shebaNumber', [
            'sheba_numbers', 'bankAccounts'
        ])
    },
    mounted() {
        this.initial()
    },
    methods: {
        initial() {
            $('#sheba_number_repeater').repeater({
                initEmpty: false,
            
                isFirstItemUndeletable: true,
                
                show: function () {
                    $(this).slideDown();
                    Inputmask("9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('#sheba_number input'))
                    Inputmask("9999-9999-9999-9999").mask(document.querySelectorAll('#card_number input'))
                },

                defaultValues: {
                    'text-input': null
                },

                hide: function (deleteElement) {                
                    $(this).slideUp(deleteElement);                 
                }
            });

            //initial inputs
            Inputmask("9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('#sheba_number input'))
            Inputmask("9999-9999-9999-9999").mask(document.querySelectorAll('#card_number input'))
        },
        submitForm(e) {
            let btn = $('#submit_btn')
            let is_valid = true;
            // let valid_card_number = true;
            // let valid_account_number = true;
            let sheba_numbers = []
            // let cardNumbers = []
            // let accountNumbers = []

            let submit_promise = new Promise((resolve, reject) => {
                $('#sheba_number input').map((index, item) => {
                    const value = $(item).prop('value')
                    if(value) {
                        const sheba = 'IR'+value.split('-').join('')
                        if(!IranSheba.isValid(sheba)) {
                            this.addValidationError(item)
                            is_valid = false
                        }else {
                            this.rmValidationError(item)
                            sheba_numbers.push({
                                id: $(item).data('id'),
                                value: value
                            })
                        }
                    }else {
                        this.addValidationError(item)
                    }
                    
                    ////9701-8000-0000-0035-2452-2542
                    ////040560081380071313621001
                })

                // $('#card_number input').map((index, item) => {
                //     let card_number_value = $(item).prop('value').split('-').join('')
                //     let correct_format_card = card_number_value.match(/[0-9]/gi)
                //     if(correct_format_card !== null) {
                //         if (cardNumber.hasOwnProperty(card_number_value.substr(0, 6))) {
                //             if(correct_format_card.length !== 16) {
                //                 valid_card_number = false
                //                 this.cardNumberValidationError(item)
                //             }
                //             else {
                //                 if(this.isValidCardNumber(card_number_value)) {
                //                     this.rmValidationError(item)
                //                     cardNumbers.push({
                //                         id: $(item).data('id'),
                //                         value: card_number_value
                //                     })
                //                     valid_card_number = true
                //                 }
                //                 else {
                //                     this.cardNumberValidationError(item)
                //                     valid_card_number = false
                //                 }
                //             }
                //         } else {
                //             this.cardNumberValidationError(item)
                //             valid_card_number = false
                //         }
                //     }
                //     else {
                //         this.cardNumberValidationError(item)
                //         valid_card_number = false
                //     }
                // })

                // $('#account_number input').map((index, item) => {
                //     let account_number_value = $(item).prop('value')
                //     if(account_number_value) {
                //         accountNumbers.push({
                //             id: $(item).data('id'),
                //             value: account_number_value
                //         })
                //         valid_account_number = true
                //         this.rmValidationError(item)
                //     }
                //     else {
                //         valid_account_number = false
                //         this.accountNumberValidationError(item)
                //     }
                // })


                // if(cardNumbers.length > 0) {
                //     for(let x=0; x < cardNumbers.length; x++) {
                //         if (cardNumbers[x].length > 0 || cardNumbers[x]['value'] === '____-____-____-____') {
                //             let bankCode = cardNumbers[x]['value'].substr(0, 6)
                //             let bank = IranSheba.recognize('IR'+sheba_numbers[x]['value'].split('-').join(''))
                //             if (cardNumber[bankCode] !== bank.persianName) {
                //                 this.showMsg($('#sheba_number_repeater'), 'danger', this.$t('validation.conflict_cardNumber_sheba'))
                //                 is_valid = false;
                //                 KTUtil.scrollTop()
                //             }
                //         }
                //     }
                // }

                let params = {
                    // 'cardNumbers'    : cardNumbers,
                    'shebaNumbers'   : sheba_numbers,
                    // 'accountNumbers' : accountNumbers
                }

                resolve(params)
            })

            sheba_numbers.length > 0 && //cardNumbers.length > 0 &&
                    is_valid && //valid_account_number && valid_card_number &&
            submit_promise.then(params => {
                KTApp.progress(btn)
                shebaNumberService.sync({
                    params: params
                }).then(response => {
                    this.showMsg($('#sheba_number_repeater'), 'success', response.data.message)
                    KTApp.unprogress(btn)
                    KTUtil.scrollTop()
                })
            })

        },
        addValidationError(item) {
            this.rmValidationError(item)
            this.deleteBankName(item)
            new Promise((resolve, reject) => {
                let elem = document.getElementById($(item).prop('name')+'-error')
                if(elem) {
                    elem.parentNode.removeChild(elem)
                }

                resolve()
            }).then(() => {
                let error_el = '<div id="'+$(item).prop('name')+'-error" class="d-block error invalid-feedback pl-3">'+this.$t('validation.invalid_sheba_number')+'</div>'
                $(item).closest('.input-group').append(error_el)
            })
        },
        // accountNumberValidationError(item) {
        //     this.rmValidationError(item)
        //     new Promise((resolve, reject) => {
        //         let elem = document.getElementById($(item).prop('name')+'-error')
        //         if(elem) {
        //             elem.parentNode.removeChild(elem)
        //         }
        //
        //         resolve()
        //     }).then(() => {
        //         let error_el = '<div id="'+$(item).prop('name')+'-error" class="d-block error invalid-feedback pl-3">'+this.$t('validation.invalid_account_number')+'</div>'
        //         $(item).closest('.input-group').append(error_el)
        //     })
        // },
        // cardNumberValidationError(item) {
        //     this.rmValidationError(item)
        //     this.deleteBankName(item)
        //     new Promise((resolve, reject) => {
        //         let elem = document.getElementById($(item).prop('name')+'-error')
        //         if(elem) {
        //             elem.parentNode.removeChild(elem)
        //         }
        //
        //         resolve()
        //     }).then(() => {
        //         let error_el = '<div id="'+$(item).prop('name')+'-error" class="d-block error invalid-feedback pl-3">'+this.$t('validation.invalid_card_number')+'</div>'
        //         $(item).closest('.input-group').append(error_el)
        //     })
        // },
        rmValidationError(item) {
            let elem = document.getElementById($(item).prop('name')+'-error')
            if(elem) {
                elem.parentNode.removeChild(elem)
            }
        },
        // isValidCardNumber(card_number) {
        //     let odd = [],
        //         even = [];
        //
        //     for (let i = 0; i < card_number.length; i++) {
        //         i % 2 === 0
        //             ? even.push(card_number[i] * 2)
        //             : odd.push(card_number[i] * 1)
        //     }
        //
        //     for(let j = 0; j < even.length; j++) {
        //         if(even[j] > 9) {
        //             even[j] = even[j] - 9
        //         }
        //     }
        //     even = even.reduce(function (total, currentValue) {return total + currentValue;}, 0);
        //     odd = odd.reduce(function (total, currentValue) {return total + currentValue;}, 0);
        //
        //     return (even + odd) % 10 === 0;
        // },
        deleteBankName(item) {
            let elem = document.getElementById($(item).prop('name')+'-icon')
            if(elem) {
                elem.parentNode.removeChild(elem)
            }
        }
    }
}
</script>

<style>

</style>